import React from 'react';

import { LocaleContext } from '@/hooks/useTranslator';
import { Locale } from '@/types/locale';
import { numbersLocale } from '@/utility/numbersLocale';

export const useLocalizedFormatter = (options: Intl.NumberFormatOptions): Intl.NumberFormat => {
  const locale = React.useContext<Locale>(LocaleContext);

  return new Intl.NumberFormat(numbersLocale(locale), options);
};
